<template>
  <SectionContainer :colors="colors" :background-variant="backgroundVariant" class="w-full"
  >
    <div class="w-full flex flex-col">
      <div class="max-w-6xl mx-auto text-center">
        <component :is="headingTag" class="text-3xl md:text-4xl font-bold" style="color: var(--theme-text-heading);">
          {{ title }}
        </component>
        <p class="text-lg mt-2" style="color: var(--theme-text-body);">
          {{ subText }}
        </p>
      </div>

      <!-- Testimonials Grid -->
      <div class="mt-10 flex flex-wrap justify-center gap-6" :style="cssVars">
        <component
            :is="cardComponent"
            v-for="(testimonial, index) in content.filter(c => c.quote !== '' && c.name !== '')"
            :key="index"
            v-motion
            :initial="{ opacity: 0, y: 30 }"
            :visible="{ opacity: 1, y: 0 }"
            :transition="{ duration: 1.5, ease: 'easeOut' }"
            :colors="colors"
            :variant="index % 2 === 0 ? 1 : 2"
            class="p-6 max-w-md text-center"
        >
          <div class="h-full rounded" >
            <p class="mt-4 italic" style="color: var(--theme-text-body);">
              "{{ testimonial.quote }}"
            </p>
            <h3 class="mt-4 font-bold" style="color: var(--theme-text-heading);">
              {{ testimonial.name }}
            </h3>
            <p class="text-sm" style="color: var(--theme-text-muted);">
              {{ testimonial.company }}
            </p>
          </div>
        </component>
      </div>

    </div>
  </SectionContainer>
</template>

<script setup>
import {useSectionHeadingTag} from "@/composables/useSectionHeadingTag.js";
import {computed} from "vue";
import SectionContainer from "@/components/SectionContainer.vue";
import {useThemedComponent} from "@/composables/useThemedComponent.js";
const headingTag = useSectionHeadingTag();

const cardComponent = useThemedComponent("card");

const props = defineProps({
  title: {type: String, required: true},
  subText: {type: String, default: ""},
  content: {type: Array, required: true},
  backgroundVariant: {type: Number, default: 1}, // Alternates background
  colors: {type: Object, required: true} // Use colors from the schema
});

// Compute CSS variables for dynamic background and card colors
const cssVars = computed(() => ({
  "--bg-light-variant-1": "#ffffff",
  "--bg-light-variant-2": props.colors.lightest,
  "--bg-dark-variant-1": props.colors.dark,
  "--bg-dark-variant-2": props.colors.darkest,
  "--card-light": props.colors.white,
  "--card-light-alt": props.colors.whitest,
  "--card-dark": props.colors.dark,
  "--card-dark-alt": props.colors.darkest,
  "--border-color-light": props.colors.accent,
  "--border-color-dark": props.colors.accentDark
}));

// Dynamically set background class using Tailwind dark mode
const computedBackgroundClass = computed(() =>
    props.backgroundVariant === 1
        ? "bg-[var(--bg-light-variant-1)] dark2:bg-[var(--bg-dark-variant-1)]"
        : "bg-[var(--bg-light-variant-2)] dark2:bg-[var(--bg-dark-variant-2)]"
);


</script>

<style scoped>
/* Smooth background transitions */
.transition-colors {
  transition: background-color 0.3s ease-in-out;
}
</style>
